import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Configuration} from '@shared/models/configuration';
import {KeycloakService} from 'keycloak-angular';
import {ConsentOrchestratorService} from 'src/app/services/consent-orchestrator.service';
import {AreaRiservataService} from '../../../../services/area-riservata.service';
import {AuthService} from '../../../../services/auth.service';
import {CartService} from '../../../../services/cart.service';
import {GenericService} from '../../../../services/generic.service';
import {GtmDatalayerService} from '../../../../services/gtm-datalayer.service';
import {UserService} from '../../../../services/user.service';
import {LoadingCoordinatorService} from '../../../../services/loading-coordinator.service';
import {STRUCTURELINKMEGAMENU} from './components/megamenu/structure_menu.model';
import {HeaderMegamenuTopComponent} from './components/header-megamenu-top/header-megamenu-top.component';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {MegamenuComponent} from './components/megamenu/megamenu.component';
import {LoginBoxComponent} from './components/login-box/login-box.component'
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {ContentService} from 'src/app/services/content.service';
import {documentToHtmlString} from '@contentful/rich-text-html-renderer';
import {NotificationBarComponent} from "@shared/components/web/notification-bar/notification-bar.component";
import {AppIconComponent} from '@shared/components/app-icon';
import {StartupService} from "../../../../services/startup.service";
import {APP_CONFIG, AppConfig} from "../../../../app-config.model";
import {
  afterNextRender,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  HostListener,
  Inject,
  inject,
  OnInit,
  PLATFORM_ID,
  signal
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FocusTrapDirective} from '@shared/directives/focus-trap.directive';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [HeaderMegamenuTopComponent, MegamenuComponent, LoginBoxComponent, RouterLink, RouterLinkActive, NotificationBarComponent, FocusTrapDirective, AppIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, AfterViewInit {
  private readonly configEnv = inject<AppConfig>(APP_CONFIG);
  private readonly destroyRef = inject(DestroyRef);
  private readonly loadingCoordinator = inject(LoadingCoordinatorService);
  structureLinkMegamenu = STRUCTURELINKMEGAMENU;
  showMenuProducts: boolean;
  showMenuChisiamo: boolean;
  readonly product = signal<any>(undefined);
  readonly showMenuUser = signal(false);
  showMenuNum: boolean;
  showMenuContatti: boolean;
  readonly user = signal<any>(null);
  hasMenu: boolean;
  hasSearch: boolean;
  hasUserMenu: boolean;
  hasInfo: boolean;
  backHome: boolean;
  isDesktop = this.genericService.isDesktop();
  searchForm: UntypedFormGroup;
  readonly showRegistrationTooltip = signal(false);
  readonly showResetPasswordTooltip = signal(false);
  enabledCart = this.configEnv.ENABLECART;
  readonly isAreaRiservataLoginPage = signal(false);
  readonly notificationBarText = signal<any>(null);

  configurationSearch: Configuration = {
    clickableElement: true,
    disabled: false,
    lightTextColor: true,
    /* iconFont: 'search', */
    img: { src: '../../../../../../assets/img/search.svg', alt: 'search' },
    label: 'Cosa stai cercando?',
    placeholder: 'Cosa stai cercando?',
  };
  productsLinkViaggi = [
    {
      url: '/prodotti-per-te/viaggi/viaggi-nostop-vacanza',
      label: 'Assicurazione Viaggio'
    },
    {
      url: '/prodotti-per-te/viaggi/cancellation-top',
      label: 'Cancellation Top'
    },
    {
      url: '/prodotti-per-te/viaggi/viaggi-nostop-vacanza-multiviaggio',
      label: 'Annuale Multiviaggio'
    },
    {
      url: '/prodotti-per-te/viaggi/viaggi-nostop-usa-canada',
      label: 'Viaggi USA'
    },

  ]

  constructor (
    private authService: AuthService,
    private genericService: GenericService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private areaRiservataService: AreaRiservataService,
    private gtmDatalayerService: GtmDatalayerService,
    private userService: UserService,
    public cartService: CartService,
    private keycloak: KeycloakService,
    private startupService: StartupService,
    private consentOrchestratorService: ConsentOrchestratorService,
    private contentService: ContentService,
     @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.showMenuProducts = false;
    this.showMenuChisiamo = false;
    this.showMenuUser.set(false);
    this.showMenuNum = false;
    this.showMenuContatti = false;
    if(isPlatformBrowser(this.platformId)) {
       afterNextRender(() => {
        this.userService.userSub.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( ( res ) => {
          this.user.set(res);
          console.info("USER LOADED");

          if ( res ) {
            if (location.search &&
              location.search.indexOf( 'notificationLogin' ) !== -1) {
              this.showRegistrationTooltip.set(true);
              this.showResetPasswordTooltip.set(true);
              this.showRegistrationTooltip.set(false);
              this.showResetPasswordTooltip.set(false);
            }
          }
        } );
       });
    }

    this.configureHeaderLayout(this.router.url);

    this.searchForm = this.fb.group( {
      search: [null, []],
    } );
  }

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId) && window.location.pathname.includes('/prodotti-per-te')) {
           setTimeout(() => {
        //Titolo trigger: Page View
            console.log('FUNNEL HEADER: ');
            this.consentOrchestratorService
              .trackSecureEvent(
                {
                  name: this.configEnv.PAGE_VIEW,
                  properties: {
                    "path": window.location.href,
                    "bindingid": ""
                  }
                }
              );
    }, 2000)}

    //TODO CAPIRE COME TESTARE QUEST "INDEXOF"
    if (isPlatformBrowser(this.platformId)
      && location.search
      && location.search.indexOf( 'registrazione' ) != -1 ) {
      //setTimeout( () => {
        //this.user.set(this.authService.getUser());
        if ( location.search.indexOf( 'modificaNumero' ) != -1 ) {
          this.router.navigate(['area-riservata/tuoi-dati']);
          // TODO verificare -- this.stateService.go(this.genericService.viewRoot() + '.AreaRiservata.TuoiDati');
        } else {
          this.showRegistrationTooltip.set(true);
            this.showRegistrationTooltip.set(false);
         // }, 4000 );
        }
      //}, 200 );
    } else {
      //setTimeout( () => {
      /*if(isPlatformBrowser(this.platformId)) {
        if (this.user() ) {
          const data2 = sessionStorage.getItem( 'checkSessione' );
          if ( !data2 && location.href.indexOf( '/funnel/summary' ) === -1 ) {
            this.authService.getLoginByCookie().subscribe( ( res ) => {
              if ( res ) {
                sessionStorage.setItem( 'checkSessione', 'open' );
              }
            } );
          }
        }
      }*/
      //}, 200 );
    }
    // Da fixare e rilasciare al prossimo rilascio
    /* this.utilityService.userExistsAreapvt.subscribe((user) => {
      if(user) {
        this.userExists = user;
      }
    }) */


  }

  private configureHeaderLayout(url: string): void {
    const currentPath = url.split(/[?#]/)[0];

    this.isAreaRiservataLoginPage.set(currentPath === '/area-riservata/login');

    switch (this.router.routerState.snapshot.url) { // TODO vericare il corretto utilizo del switch --------this.stateService.current.name ) {
      case 'View.Account.CompletaRegistrazione':
      case 'View.Account.Registrazione':
      case 'View.Account.RegistrationLight':
      case 'Mobile.Account.RegistrationLight':
      case 'View.Account.ExtraDataLight':
      case 'Mobile.Account.ExtraDataLight':
        this.hasMenu = false;
        this.hasSearch = false;
        this.hasUserMenu = false;
        this.hasInfo = false;
        this.backHome = true;
        break;
      default:
        this.hasMenu = true;
        this.hasSearch = true;
        this.hasUserMenu = true;
        this.hasInfo = true;
        this.backHome = false;
        break;
    }
  }

  ngAfterViewInit(): void {
    if(isPlatformServer(this.platformId)) {return;}
    this.contentService.GetNotificationBar().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if(res) {
        this.notificationBarText.set(documentToHtmlString(res.notification));
      }
    })
  }
  //DEPRECATED
  checkRoute() {
    switch ( this.router.url ) { // TODO sistemare switch --- this.stateService.current.name ) {
      case 'View.Account.RegistrationLight':
      case 'Mobile.Account.RegistrationLight':
      case 'View.Account.ExtraDataLight':
      case 'Mobile.Account.ExtraDataLight':
      /* TODO VERIFICARE if ( this.authService.getUser() ) {
          this.authService.logout();
        }*/
    }
    this.router.navigate(['/'])
    //this.stateService.go( this.genericService.viewRoot() + '.ContentPage', {slugPath: '/',} );
    if ( sessionStorage.getItem( 'prodottiCorrelati' ) ) {
      sessionStorage.removeItem( 'prodottiCorrelati' );
    }
  }
  /**@deprecated*/
  goToCart() {
      this.router.navigate(['/funnel/carrello'])
     // TODO this.stateService.go(this.genericService.viewRoot().toUpperCase() === 'MOBILE' ? "Mobile.Cart" : "Funnel.Cart");

  }

  toggleMenuUser() {
    if ( this.areaRiservataService.getIsMFAActive() && !this.user() ) {
      this.keycloak.login( { redirectUri: window.location.origin } ).then( ( res ) => {
        console.log("LOGIN KEY CLOAK");
      } );
    } else {
      this.showMenuUser.update(v => !v);
      this.showRegistrationTooltip.set(false);

      if ( this.showMenuUser() && !this.user() ) {
        this.gtmDatalayerService.trackLogin();
        this.gtmDatalayerService.trackVirtualPopup( 'login' );
      }
    }
  }

  onCloseLogin( isLoggedIn: boolean ) {
    if ( isLoggedIn ) {
      this.user.set(this.authService.getUser());
      this.router.navigate(['/']);
    }
    //this.toggleMenuUser();
  }

  logout() {
    const loading = this.loadingCoordinator.begin({kind: 'operation'});
    this.authService.logout().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe( () => {
      this.areaRiservataService.resetUserProfile();
      this.user.set(null);
      sessionStorage.removeItem( 'checkSessione' );
      this.showMenuUser.set(false);
      if ( this.keycloak.isLoggedIn() ) {
        this.keycloak.logout( window.location.origin ).then( ( l ) => {
          console.log("LOGOUT")
        });
        this.keycloak.clearToken();
        this.startupService.load().toPromise().finally(() => loading.finish());
      } else {
        this.startupService.load().toPromise().finally(() => loading.finish());
        this.router.navigate(['/']);
      }
    }, (err) => {
      console.error("Logout error:", err);
      loading.finish();
    });
  }

  goBackToHome() {
    this.checkRoute();
  }

  search() {
    this.router.navigate(['/']);
    // TODO esiste ancora la ricerca? -- this.stateService.go( this.genericService.viewRoot() + '.Ricerca', {k: this.searchForm.getRawValue().search,} );
  }

  /**
   * @param {string} url
   * @return {*}
   * @memberof HeaderComponent
   */
  navigateByUrl( url: string ) {
    if ( url && url.length > 0 ) {
      return window.open( url );
    }
    return null;
  }

  openMegamenu(item: { product_title_menu: string; activeArrow?: boolean }) {
    this.product.set(item.product_title_menu);
    item.activeArrow = true;
  }

  closeMegamenu(item?: { activeArrow?: boolean }) {
    this.product.set(undefined);
    if (item) {
      item.activeArrow = false;
      return;
    }
    this.structureLinkMegamenu.forEach((menuItem) => {
      menuItem.activeArrow = false;
    });
  }

  onMegamenuKeydown(event: KeyboardEvent, item: { product_title_menu: string; activeArrow?: boolean }) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (this.product() === item.product_title_menu) {
        this.closeMegamenu(item);
      } else {
        this.openMegamenu(item);
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.closeMegamenu();
    }
  }

  closeUserMenu() {
    this.showMenuUser.set(false);
  }

  @HostListener('document:keydown.escape')
  onDocumentEscape() {
    if (this.product()) {
      this.closeMegamenu();
    }
    if (this.showMenuUser()) {
      this.closeUserMenu();
    }
  }
}
